module.exports = __webpack_public_path__ + "bj.svg?f541db1f616ff30a922b1be964f0ce78";